import { API_BASE_URL } from '../config/api';

class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

export const genreApi = {
  async getAllGenres(): Promise<string[]> {
    try {
      console.log('Getting all genres');
      console.log('API URL:', `${API_BASE_URL}/api/Genre`);
      
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${API_BASE_URL}/api/Genre`, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      console.log('Get genres response status:', response.status);

      let data;
      try {
        data = await response.json();
        console.log('Get genres response data:', data);
      } catch (jsonError) {
        console.error('Failed to parse JSON response:', jsonError);
        throw new ApiError(response.status, 'Invalid response format from server');
      }

      if (!response.ok) {
        console.error('Get genres failed with status:', response.status);
        throw new ApiError(response.status, data.message || 'Failed to get genres');
      }

      return data;
    } catch (error) {
      console.error('Get genres error:', error);
      if (error instanceof ApiError) {
        throw error;
      }
      throw new ApiError(0, 'Network error occurred: ' + (error instanceof Error ? error.message : 'Unknown error'));
    }
  },
};